export enum EnumModuleType {
  BCLedger,
  Clients,
  Orders,
  SamplePO,
  Users,
  InvcPrv,
  CDI,
  ProductionWorkflow,
}
